let tokensLocalStorage = {};
  tokensLocalStorage.init = function() {
      let tokens = localStorage.getItem('tokens')
      if (!tokens) {
        tokens = '{}'
      }
      return JSON.parse(tokens)
    }
  
    tokensLocalStorage.get= function(item = '')  {
      let tokens = this.init()
      return item === '' ? tokens : tokens[item]
    },
  
    tokensLocalStorage.set= function(item, value) {
      let tokens = this.init()
      tokens[item] = value
      localStorage.setItem('tokens', JSON.stringify(tokens))
    },

    tokensLocalStorage.delete= function(item) {
      let tokens = this.init()
      delete tokens[item]
      localStorage.setItem('tokens', JSON.stringify(tokens))
    }

export default tokensLocalStorage    



// WEBPACK FOOTER //
// ./src/service/tokens.js